import { IconNames } from '@shipengine/giger-theme';
import { getDetailsStyles, getSummaryStyles, getIconStyles, getPanelStyles } from './Accordion.styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Icon } from '../../../components/Icon/Icon.js';

const Accordion = _ref => {
  let {
    children,
    initialExpanded = true,
    summary,
    ...rest
  } = _ref;
  return jsxs("details", {
    css: getDetailsStyles,
    open: initialExpanded,
    ...rest,
    children: [jsxs("summary", {
      css: getSummaryStyles,
      children: [summary, jsx(Icon, {
        css: getIconStyles,
        id: "chevron-icon",
        name: IconNames.CHEVRON_BOTTOM
      })]
    }), jsx("div", {
      css: getPanelStyles,
      children: children
    })]
  });
};

export { Accordion };
//# sourceMappingURL=Accordion.js.map
